var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"stamp-list__item stamp-grid__item",style:(_vm.stempItemStyles),on:{"click":_vm.clickStamp}})
}
var staticRenderFns = []

export { render, staticRenderFns }